import NprSuggest from '../../NprSuggest';
import { NprResultTypes } from '@src/utils/enums';

import { commonQuestionData, QuestionDataById } from '@components/dynamic-form/types';
import { QUESTION_TYPE } from '@src/app-components/dynamic-form/dynamic-form.validation';
import { getParentObjectV2 } from '../../nprData.types.V2';

const yesNoNotSureOptions = [
  {
    listId: 1,
    valueDesc: 'Yes',
    sortOrder: 1.0,
    activeInd: true,
  },
  {
    listId: 1,
    valueDesc: 'No',
    sortOrder: 1.0,
    activeInd: true,
  },
  {
    listId: 1,
    valueDesc: "I'm not sure",
    sortOrder: 1.0,
    activeInd: true,
  },
];

export const nprQuestionsByIdV2: QuestionDataById = {
  1: {
    sectionId: 1,
    helpInfo:
      'Examples include: Floating docks, powerlines, dredging, and informational buoys located in, over, or under a navigable water. Generally, navigable waters are those waters of the United States that are subject to the ebb and flow of the tide shoreward to the mean high water mark, and/or are presently used, or have been used in the past, or may be susceptible to use to transport interstate or foreign commerce. Definitions for Section 10 of the Rivers and Harbors Act of 1899 are provided at [33 CFR 322.2](https://www.ecfr.gov/current/title-33/section-322.2).',
    question:
      'Are you planning to conduct work or install structures in, over, or under navigable water of the United States under Section 10 of the Rivers and Harbors Act of 1899?',
    questionTypeId: QUESTION_TYPE.option,
    lists: yesNoNotSureOptions,
    endConditions: [
      {
        value: yesNoNotSureOptions[0].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: yesNoNotSureOptions[2].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  2: {
    sectionId: 1,
    helpInfo:
      'Definitions for Section 103 of the Marine Protection, Research, and Sanctuaries Act are provided at [33 CFR 324.2](https://www.ecfr.gov/current/title-33/section-324.2).',
    question: 'Are you planning to transport dredged material for the purpose of dumping it in ocean waters?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(1, QUESTION_TYPE.option, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  3: {
    sectionId: 1,
    helpInfo: `Examples include:
      - Placement of fill that is necessary for the construction of any structure or infrastructure in a water of the United States
      - The building of any structure, infrastructure, or impoundment requiring rock, sand, dirt, or other material for its construction
      - Site-development fills for recreational, industrial, commercial, residential, or other uses
      - Causeways or road fills
      - Dams and dikes
      - Artificial islands
      - Property protection and/or reclamation devices such as riprap, groins, seawalls, breakwaters, and revetments
      - Beach nourishment
      - Levees
      - Fill for structures such as sewage treatment facilities, intake and outfall pipes associated with power plants and subaqueous utility lines
      - Placement of fill material for construction or maintenance of any liner, berm, or other infrastructure associated with solid waste landfills
      - Placement of overburden, slurry, or tailings or similar mining-related materials
      - Artificial reefs
      - Mechanized grading
  Temporary placement of fill material in waters requires a permit. Definitions for Section 404 of the Clean Water Act are provided at [33 CFR 323.2](https://www.ecfr.gov/current/title-33/chapter-II/part-323/section-323.2).`,
    question:
      'Are you planning to discharge (dump, place, deposit, redistribute) dredged or fill material into a waterbody or wetland?',
    questionTypeId: QUESTION_TYPE.option,
    lists: yesNoNotSureOptions,
    parentQuestions: [getParentObjectV2(2, QUESTION_TYPE.yesNo, '=', 'NO')],
    endConditions: [
      {
        value: yesNoNotSureOptions[2].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.JurisdictionalDetermination} />,
      },
    ],
    ...commonQuestionData,
  },
  3.1: {
    sectionId: 1,
    question:
      'If you believe your project may be occurring outside of USACE geographically regulated waters and are requesting confirmation to that effect, please submit an AJD request. You may also contact your [district](https://regulatory.ops.usace.army.mil/offices/) for an NPR letter for geographic jurisdiction.',
    questionTypeId: 99,
    parentQuestions: [getParentObjectV2(3, QUESTION_TYPE.option, '=', yesNoNotSureOptions[2].valueDesc)],
    alertType: 'warning',
    ...commonQuestionData,
  },
  4: {
    sectionId: 1,
    helpInfo:
      'Waters of the United States are defined at [33 CFR 328.3](https://www.ecfr.gov/current/title-33/section-328.3).',
    question: 'Is waterbody that would be affected known or presumed to be a water of the United States?',
    questionTypeId: QUESTION_TYPE.option,
    lists: yesNoNotSureOptions,
    parentQuestions: [getParentObjectV2(3, QUESTION_TYPE.option, '=', 'YES')],
    endConditions: [
      {
        value: yesNoNotSureOptions[1].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.JurisdictionalDetermination} />,
      },
      {
        value: yesNoNotSureOptions[2].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.JurisdictionalDetermination} />,
      },
    ],
    ...commonQuestionData,
  },
  4.1: {
    sectionId: 1,
    question:
      'If you believe your project may be occurring outside of USACE geographically regulated waters and are requesting confirmation to that effect, please submit an AJD request. You may also contact your [district](https://regulatory.ops.usace.army.mil/offices/) for an NPR letter for geographic jurisdiction.',
    questionTypeId: 99,
    parentQuestions: [getParentObjectV2(4, QUESTION_TYPE.option, '=', 'NO')],
    alertType: 'warning',
    ...commonQuestionData,
  },
  4.2: {
    sectionId: 1,
    question:
      'If you believe your project may be occurring outside of USACE geographically regulated waters and are requesting confirmation to that effect, please submit an AJD request.',
    questionTypeId: 99,
    parentQuestions: [getParentObjectV2(4, QUESTION_TYPE.option, '=', yesNoNotSureOptions[2].valueDesc)],
    alertType: 'warning',
    ...commonQuestionData,
  },
  5: {
    sectionId: 1,
    question: 'Are you constructing a floating dock that has no associated discharge of dredged or fill material?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(3, QUESTION_TYPE.option, '=', 'NO')],
    endConditions: [
      {
        value: yesNoNotSureOptions[0].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprLetter} />,
      },
    ],
    ...commonQuestionData,
  },
  6: {
    sectionId: 1,
    helpInfo:
      'Note: Return water from a contained disposal area is considered a "discharge of dredged material" and requires authorization.',
    question:
      'Are you excavating material from a non-navigable water with no associated discharge of dredged or fill material?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(5, QUESTION_TYPE.yesNo, '=', 'NO')],
    ...commonQuestionData,
  },
  7: {
    sectionId: 1,
    helpInfo: `Incidental fallback means the redeposit of small volumes of dredged material that is incidental to excavation activity in waters of the United States when such material falls back to substantially the same place as the initial removal.
Additional information regarding incidental feedback can be found at:
 1. [33 CFR 323.2(d)(3)(i)](https://www.ecfr.gov/current/title-33/part-323#p-323.2(d)(3)(i))
 2. [33 CFR 323.2(d)(3)(ii)](https://www.ecfr.gov/current/title-33/part-323#p-323.2(d)(3)(ii))`,
    question: 'Will your project only involve incidental fallback in a water of the United States?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(6, QUESTION_TYPE.yesNo, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprLetter} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  8: {
    sectionId: 1,
    helpInfo:
      'Pile supported structures such as piers, boardwalks and walkways placed in waters of the United States are typically not considered fill material.',
    question:
      'Are you constructing a pile supported structure with no associated discharge of dredged or fill material?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(6, QUESTION_TYPE.yesNo, '=', 'NO')],
    ...commonQuestionData,
  },
  9: {
    sectionId: 1,
    helpInfo: `Examples of projects that would cause the effect of fill include:
    - Projects where the pilings are so closely spaced that sedimentation rates would be increased
    - Projects in which the pilings themselves effectively would replace the bottom of a waterbody
    - Projects involving the placement of pilings that would reduce the reach or impair the flow or circulation of waters of the United States
    - Projects involving the placement of pilings which would result in the adverse alteration or elimination of aquatic functions
    See [33 CFR 323.3(c)](https://www.ecfr.gov/current/title-33/chapter-II/part-323#p-323.3(c)).`,
    question: 'Will the piles be placed in a manner such that they will not have the effect of fill?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(8, QUESTION_TYPE.yesNo, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprLetter} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  10: {
    sectionId: 1,
    helpInfo:
      'Examples of activities which do not discharge dredged or fill material include activities such as land surveying or subdividing, painting an existing structure, or vegetation clearing above the ground where these activities do not have the effect of fill. See [33 CFR 323.2](https://www.ecfr.gov/current/title-33/section-323.2) for the definitions of discharge of dredged and fill material. Activities occurring in non-navigable waters of the United States which do not discharge dredged or fill material do not require a permit from USACE Regulatory. Note: it is not considered discharge of dredged or fill material when the activity involves only the cutting or removing of vegetation above the ground (e.g., mowing, rotary cutting, and chainsawing) where the activity neither substantially disturbs the root system nor involves mechanized pushing, dragging, or other similar activities that redeposit excavated soil material.',
    question:
      'Will your activity involve the discharge of dredged or fill material anywhere within the project boundary?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(8, QUESTION_TYPE.yesNo, '=', 'NO')],
    endConditions: [
      {
        value: yesNoNotSureOptions[0].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.JurisdictionalDetermination} />,
      },
      {
        value: yesNoNotSureOptions[1].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprLetter} />,
      },
    ],
    ...commonQuestionData,
  },
  10.1: {
    sectionId: 1,
    question:
      'If you believe your project may be occurring outside of USACE geographically regulated waters and are requesting confirmation to that effect, please submit an AJD request. You may also contact your [district](https://regulatory.ops.usace.army.mil/offices/) for an NPR letter for geographic jurisdiction.',
    questionTypeId: 99,
    parentQuestions: [getParentObjectV2(10, QUESTION_TYPE.yesNo, '=', 'YES')],
    alertType: 'warning',
    ...commonQuestionData,
  },
  11: {
    sectionId: 2,
    helpInfo:
      'If any discharge resulting from the exempt activities contains any toxic pollutant listed under [Section 307 of the Clean Water Act](https://www.ecfr.gov/current/title-40/section-401.15), the discharge will be subject to any applicable toxic effluent standard or prohibition, and will require a Section 404 permit.',
    question: 'Does the discharge contain a toxic pollutant listed under Section 307 of the Clean Water Act?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(4, QUESTION_TYPE.option, '=', 'YES')],
    requireAllParents: true,
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  12: {
    sectionId: 2,
    helpInfo:
      'See [33 CFR 323.4(c)](https://www.ecfr.gov/current/title-33/part-323/section-323.4#p-323.4(c)). Please note that if the purpose of the project is to convert an area of the waters of the United States into a use to which it was not previously subject, where the flow or circulation of waters of the United States may be impaired or the reach of such waters reduced, your project would not qualify for an exemption. If you have any questions, cancel this RRS Request and submit a Pre-application/Project Scoping Meeting request.',
    question:
      'Will any part of the discharge convert an area of a water of the United States into a use to which it was not previously subject, where the flow and/or circulation of waters may be impaired or the reach of the waters reduced?',
    questionTypeId: QUESTION_TYPE.option,
    lists: yesNoNotSureOptions,
    parentQuestions: [getParentObjectV2(11, QUESTION_TYPE.yesNo, '=', 'NO')],
    endConditions: [
      {
        value: yesNoNotSureOptions[0].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: yesNoNotSureOptions[2].valueDesc,
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  13: {
    sectionId: 2,
    helpInfo:
      'To fall under this exemption, the activities must be part of an established farming, silviculture, or ranching operation. These activities include plowing, seeding, cultivating, harvesting food, fiber, and forest products, or upland soil and water conservation practices. This specific exemption does not apply to farm or stock ponds, farm or forest roads, or drainage ditches. Please see [33 CFR 323.4](https://www.ecfr.gov/current/title-33/chapter-II/part-323/section-323.4) for more information on this exemption. ',
    question:
      'Does your project involve the discharge of dredged or fill material for normal farming, silviculture, and ranching activities such as plowing, seeding, cultivating, minor drainage, harvesting for the production of food, fiber, and forest products, or upland soil and water conservation practices?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(12, QUESTION_TYPE.option, '=', 'NO')],
    ...commonQuestionData,
  },
  14: {
    sectionId: 2,
    helpInfo:
      'Activities on areas laying fallow as part of a conventional rotational cycle are part of an established operation. Activities that bring an area into farming, silviculture, or ranching use are not part of an established operation. An operation is no longer established when the area on which it was conducted has been converted to another use or has lain idle so long that modifications to the hydrologic regime are necessary to resume operations.',
    question: 'Is the activity part of an established farming, silviculture, or ranching operation?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(13, QUESTION_TYPE.yesNo, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
    ],
    ...commonQuestionData,
  },
  15: {
    sectionId: 2,
    helpInfo:
      'Examples include: Emergency reconstruction of recently damaged parts of currently serviceable structures such as dikes, dams, levees, groins, riprap, breakwaters, causeways, bridge abutments or approaches, and transportation structures.',
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of maintenance, including emergency reconstruction of recently damaged parts, of currently serviceable structures such as dikes, dams, levees, groins, riprap, breakwaters, causeways, and bridge abutments or approaches, and transportation structures?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(13, QUESTION_TYPE.yesNo, '=', 'NO')],
    ...commonQuestionData,
  },
  16: {
    sectionId: 2,
    question: 'Will the activity modify the character, scope, or size of the original fill design?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(15, QUESTION_TYPE.yesNo, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  17: {
    sectionId: 2,
    question:
      'If reconstruction is necessary due to damage, will the activity occur within a reasonable period of time after damage?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(16, QUESTION_TYPE.yesNo, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  18: {
    sectionId: 2,
    helpInfo:
      'Temporary discharges that are incidental to a maintenance activity that is exempt under Section 404(f) are also exempt.',
    question: 'Will your project involve temporary impacts not directly associated with the maintenance activity?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(17, QUESTION_TYPE.yesNo, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
    ],
    ...commonQuestionData,
  },
  19: {
    sectionId: 2,
    helpInfo:
      'For more information about this exemption, see [RGL 87-09](https://cdm16021.contentdm.oclc.org/digital/collection/p16021coll9/id/1351/rec/1). Although RGL 87-09 is expired it is still considered generally relevant to implementation of the Regulatory program per [RGL 05-06](https://usace.contentdm.oclc.org/utils/getfile/collection/p16021coll9/id/1266). Some districts have additional guidance for farm and stock ponds. Please reach out to [your district](https://regulatory.ops.usace.army.mil/offices/) to review any district-specific guidance on farm and stock ponds to determine minimum sizing and/or water budgeting requirements.',
    question:
      'Does your project involve the discharge of dredged or fill material for the primary purpose of construction or maintenance of farm or stock ponds? ',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(15, QUESTION_TYPE.yesNo, '=', 'NO')],
    ...commonQuestionData,
  },
  20: {
    sectionId: 2,
    helpInfo:
      'See [33 CFR 323.4(c)](https://www.ecfr.gov/current/title-33/part-323/section-323.4#p-323.4(c)). Please note that if the purpose of the project is to convert an area of the waters of the United States into a use to which it was not previously subject, where the flow or circulation of waters of the United States may be impaired or the reach of such waters reduced, your project would not qualify for an exemption. If you have any questions, cancel this RRS Request and submit a Pre-application/Project Scoping Meeting request.',
    question:
      'Is the proposed pond designed such that the discharges will not result in significant discernable alterations to flow or circulation of the affected wetland or waterbody?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(19, QUESTION_TYPE.yesNo, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  21: {
    sectionId: 2,
    helpInfo: `Visit the [EPA's website](https://www.epa.gov/cwa-404/memorandum-clean-water-act-section-404-regulatory-program-and-agricultural-activities) for more information. Some [districts](https://regulatory.ops.usace.army.mil/offices/) have additional guidance for farm and stock ponds. Please reach out to your district to to review any district-specific guidance on farm and stock ponds to determine minimum sizing and/or water budgeting requirements.`,
    question:
      'Will the pond be constructed to the minimum size needed to support normal farming and/or ranching operations on the site, based on a demonstrable water budget which considers the anticipated needs of the farming and/or ranching operation? ',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(20, QUESTION_TYPE.yesNo, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  22: {
    sectionId: 2,
    helpInfo:
      'Some districts have additional guidance for farm and stock ponds. Please reach out to [your district](https://regulatory.ops.usace.army.mil/offices/) to to review any district-specific guidance on farm and stock ponds to determine minimum sizing and/or water budgeting requirements.',
    question:
      'Please provide the water budget, evaluation of alternative water sources, type of crop, timeline of planting, design elements to reduce the effect on aquatic resources, and any other information to support that the pond is sized properly for the activity and will not result in recapture.',
    questionTypeId: QUESTION_TYPE.file,
    parentQuestions: [getParentObjectV2(21, QUESTION_TYPE.yesNo, '=', 'YES')],
    ...commonQuestionData,
  },
  23: {
    sectionId: 2,
    helpInfo:
      'See [RGL 07-02](https://www.federalregister.gov/documents/2007/12/13/E7-24191/us-army-corps-of-engineers-corps-regulatory-guidance-letter-rgl-07-02-exemptions-for-construction-or) and the [Ditch Exemption Memo](https://www.epa.gov/system/files/documents/2022-12/Ditch%20Exemption%20Memo_Final.pdf) for additional information on the construction and maintenance of irrigation ditches and maintenance of drainage ditches, including definitions for irrigation ditches, drainage ditches, construction and maintenance.',
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of construction or maintenance of irrigation ditches, or the maintenance of drainage ditches?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(19, QUESTION_TYPE.yesNo, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
    ],

    ...commonQuestionData,
  },
  24: {
    sectionId: 2,
    helpInfo:
      'This exemption applies to the construction of temporary sedimentation basins on a construction site which does not include the placement of fill material into waters of the U.S.',
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of construction of temporary sedimentation basins on a construction site which does not include placement of fill material into the water of the United States?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(23, QUESTION_TYPE.yesNo, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
    ],
    ...commonQuestionData,
  },
  25: {
    sectionId: 2,
    helpInfo: 'Forest road means logging road or road associated with silviculture.',
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of construction or maintenance of farm roads or forest roads, or temporary roads for moving mining equipment?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(24, QUESTION_TYPE.yesNo, '=', 'NO')],
    ...commonQuestionData,
  },
  26: {
    sectionId: 2,
    helpInfo:
      'Please review the best management practices at [33 CFR 323.4(a)(6)](https://www.ecfr.gov/current/title-33/part-323#p-323.4(a)(6)).',
    question:
      'Will roads be constructed and maintained, in accordance with best management practices, to assure that flow and circulation patterns and chemical and biological characteristics of the waters are not impaired, that the reach of the waters is not reduced, and that any adverse effect on the aquatic environment will be otherwise minimized, as specified in the regulation?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(25, QUESTION_TYPE.yesNo, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  27: {
    sectionId: 2,
    question:
      'Does your project involve the discharge of dredged or fill material resulting from any activity with respect to which a State has an approved program under section 1288(b)(4) of this title which meets the requirements of subparagraphs (B) and (C) of such section, is not prohibited by or otherwise subject to regulation under this section or section 1311(a) or1342 of this title (except for effluent standards or prohibitions under section 1317 of this title)?',
    questionTypeId: QUESTION_TYPE.yesNo,
    parentQuestions: [getParentObjectV2(25, QUESTION_TYPE.yesNo, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};

export const nprQuestions = [
  nprQuestionsByIdV2[1],
  nprQuestionsByIdV2[2],
  nprQuestionsByIdV2[3],
  nprQuestionsByIdV2[3.1],
  nprQuestionsByIdV2[4],
  nprQuestionsByIdV2[4.1],
  nprQuestionsByIdV2[4.2],
  nprQuestionsByIdV2[5],
  nprQuestionsByIdV2[6],
  nprQuestionsByIdV2[7],
  nprQuestionsByIdV2[8],
  nprQuestionsByIdV2[9],
  nprQuestionsByIdV2[10],
  nprQuestionsByIdV2[10.1],
];

export const exemptionQuestions = [
  nprQuestionsByIdV2[11],
  nprQuestionsByIdV2[12],
  nprQuestionsByIdV2[13],
  nprQuestionsByIdV2[14],
  nprQuestionsByIdV2[15],
  nprQuestionsByIdV2[16],
  nprQuestionsByIdV2[17],
  nprQuestionsByIdV2[18],
  nprQuestionsByIdV2[19],
  nprQuestionsByIdV2[20],
  nprQuestionsByIdV2[21],
  nprQuestionsByIdV2[22],
  nprQuestionsByIdV2[23],
  nprQuestionsByIdV2[24],
  nprQuestionsByIdV2[25],
  nprQuestionsByIdV2[26],
  nprQuestionsByIdV2[27],
];
